import React, { useState } from 'react';
import { FaWhatsapp, FaInstagram, FaEnvelope } from 'react-icons/fa';
import { MapPin, Phone, Mail, Loader2, CheckCircle } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost/api-smartpet';

export function Contacto() {
    const [form, setForm] = useState({
        nombre: '',
        email: '',
        telefono: '',
        mensaje: '',
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess(false);

        if (!form.nombre.trim() || !form.email.trim() || !form.mensaje.trim()) {
            setError('Completá todos los campos obligatorios (*)');
            setLoading(false);
            return;
        }

        try {
            await axios.post(`${API_URL}/consultas`, form);
            setSuccess(true);
            setForm({ nombre: '', email: '', telefono: '', mensaje: '' });
        } catch (err) {
            console.error(err);
            setError('Error al enviar el mensaje. Intentá de nuevo más tarde.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="w-full bg-white rounded-3xl shadow-md p-6 md:p-8 lg:p-10">
            {success && (
                <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded-xl mb-6 flex items-center gap-2">
                    <CheckCircle size={20} /> ¡Mensaje enviado! Te responderemos a la brevedad.
                </div>
            )}

            {error && (
                <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-xl mb-6">
                    {error}
                </div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 lg:gap-16">
                {/* Columna izquierda: info de contacto */}
                <div className="space-y-6 lg:space-y-8">
                    <h4 className="font-black text-[#2a1f3d] text-xl md:text-2xl">Información de contacto</h4>
                    <div className="space-y-4">
                        <div className="flex items-center gap-4 text-[#3f3d56] text-base md:text-lg">
                            <MapPin size={24} className="text-[#6c5c94] flex-shrink-0" />
                            <span>Rosario, Argentina</span>
                        </div>
                        <div className="flex items-center gap-4 text-[#3f3d56] text-base md:text-lg">
                            <Phone size={24} className="text-[#6c5c94] flex-shrink-0" />
                            <a href="tel:+5493412275598" className="hover:text-[#6c5c94] transition">+54 9 341 2275598</a>
                        </div>
                        <div className="flex items-center gap-4 text-[#3f3d56] text-base md:text-lg">
                            <Mail size={24} className="text-[#6c5c94] flex-shrink-0" />
                            <a href="mailto:juanmatoniolo2@gmail.com" className="hover:text-[#6c5c94] transition">juanmatoniolo2@gmail.com</a>
                        </div>
                    </div>
                    <div className="flex gap-5 mt-6">
                        <a href="https://wa.me/+5493412275598" target="_blank" rel="noreferrer" className="bg-green-500 text-white p-3.5 rounded-full hover:bg-green-600 transition hover:scale-105 transform">
                            <FaWhatsapp size={26} />
                        </a>
                        <a href="https://www.instagram.com/tagsmartpet/" target="_blank" rel="noreferrer" className="bg-pink-500 text-white p-3.5 rounded-full hover:bg-pink-600 transition hover:scale-105 transform">
                            <FaInstagram size={26} />
                        </a>
                        <a href="mailto:juanmatoniolo2@gmail.com" className="bg-blue-500 text-white p-3.5 rounded-full hover:bg-blue-600 transition hover:scale-105 transform">
                            <FaEnvelope size={26} />
                        </a>
                    </div>
                </div>

                {/* Columna derecha: formulario */}
                <div className="bg-[#f8f5fc] rounded-2xl md:rounded-3xl p-6 md:p-8 lg:p-10">
                    <h4 className="font-black text-[#2a1f3d] text-xl md:text-2xl mb-6">Escribinos</h4>
                    <form onSubmit={handleSubmit} className="space-y-5">
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-1.5">
                                Nombre completo <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                name="nombre"
                                value={form.nombre}
                                onChange={handleChange}
                                placeholder="Tu nombre"
                                className="w-full p-3.5 border rounded-xl focus:outline-none focus:ring-2 focus:ring-[#6c5c94] transition"
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-1.5">
                                Email <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="email"
                                name="email"
                                value={form.email}
                                onChange={handleChange}
                                placeholder="tu@email.com"
                                className="w-full p-3.5 border rounded-xl focus:outline-none focus:ring-2 focus:ring-[#6c5c94] transition"
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-1.5">
                                Teléfono (opcional)
                            </label>
                            <input
                                type="tel"
                                name="telefono"
                                value={form.telefono}
                                onChange={handleChange}
                                placeholder="+54 9 341 1234567"
                                className="w-full p-3.5 border rounded-xl focus:outline-none focus:ring-2 focus:ring-[#6c5c94] transition"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-1.5">
                                Mensaje <span className="text-red-500">*</span>
                            </label>
                            <textarea
                                name="mensaje"
                                rows="5"
                                value={form.mensaje}
                                onChange={handleChange}
                                placeholder="Contanos qué necesitas, tus dudas, o si te interesa vender SmartPet en tu local..."
                                className="w-full p-3.5 border rounded-xl focus:outline-none focus:ring-2 focus:ring-[#6c5c94] transition resize-y"
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full bg-[#6c5c94] hover:bg-[#4a3b7a] text-white font-bold py-3.5 rounded-xl transition flex items-center justify-center gap-2 text-base md:text-lg disabled:opacity-70"
                        >
                            {loading ? (
                                <>
                                    <Loader2 size={22} className="animate-spin" /> Enviando...
                                </>
                            ) : (
                                'Enviar mensaje'
                            )}
                        </button>
                        <p className="text-xs text-gray-400 text-center">
                            * Campos obligatorios. No compartiremos tus datos con terceros.
                        </p>
                        <p className="text-xs text-gray-400 text-center">
                            Respondemos a la brevedad. ¡Estamos para ayudarte!
                        </p>
                    </form>
                </div>
            </div>
        </section>
    );
}